import { useState } from "react";
import { useT } from "@/lib/i18n";

/**
 * Accepted payment-method marks shown under the pay button — official brand
 * assets in public/payment/ (supplied by the merchant). A neutral text badge
 * is shown as fallback if a file is missing.
 */
const tile = "inline-flex h-7 items-center justify-center rounded border border-primary-200 bg-white px-1.5";

const METHODS: { name: string; file: string; fallback: string }[] = [
  { name: "iDEAL & Wero", file: "/payment/ideal-wero.svg", fallback: "iDEAL · wero" },
  { name: "Visa", file: "/payment/visa.webp", fallback: "VISA" },
  { name: "Mastercard", file: "/payment/mastercard.webp", fallback: "Mastercard" },
  { name: "Bancontact", file: "/payment/bancontact.webp", fallback: "Bancontact" },
  { name: "Apple Pay", file: "/payment/applepay.svg", fallback: "Apple Pay" },
];

function PaymentLogo({ name, file, fallback }: (typeof METHODS)[number]) {
  const [broken, setBroken] = useState(false);
  return (
    <span className={tile} title={name}>
      {broken ? (
        <span className="text-[10px] font-bold text-primary-700">{fallback}</span>
      ) : (
        <img src={file} alt={name} className="h-5 w-auto" onError={() => setBroken(true)} />
      )}
    </span>
  );
}

export function PaymentIcons() {
  const t = useT();
  return (
    <div className="flex flex-wrap items-center justify-center gap-1.5" aria-label={t("Geaccepteerde betaalmethoden")}>
      {METHODS.map((m) => (
        <PaymentLogo key={m.name} {...m} />
      ))}
    </div>
  );
}
